class NetworkOutput {
  constructor(outputs) {
    this.outputs = outputs.outputs
    this.outputMap = outputs.outputMap
    this.zMap = outputs.zMap
  }

  // calculate loss
  loss(expectedOutputs, lossFunc="mse") {
    if(lossFunc == "mse") {
      lossFunc = this.#mse
    }

    return lossFunc(this.outputs, expectedOutputs)
  }

  // calculate derivative of loss function with respect to outputs
  loss_derivative(expectedOutputs, lossFunc="mse") {
    if(lossFunc == "mse") {
      var lossFunc_prime = this.#mse_prime
    }

    return lossFunc_prime(this.outputs, expectedOutputs)
  }

  // mean squared error
  #mse(actual, expected) {
    var loss = 0

    for(let i = 0; i < actual.length; i++) {
      loss += (actual[i] - expected[i]) ** 2
    }

    return loss/2
  }

  // derivative of mean squared error wrt outputs
  #mse_prime(actual, expected) {
    var d_loss = []
    for(let i=0; i < actual.length; i++) {
      d_loss.push(actual[i]-expected[i])
    }

    return d_loss
  }
}

export {
  NetworkOutput
}